module.exports = __webpack_public_path__ + "static/media/Football.411f264e.webp";